import { toast } from 'react-toastify';
import { toastMessageSuccess } from '@rsos/components/capstone/base/Toast/ToastComponents';
import { ACCEPTED } from '@rsos/constants/alertStatuses';
import {
  TRAIN_INCIDENT_ALERT_TYPE,
  ACTIVE_ASSAILANT_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import { NOTIFIED_AGENCY } from '@rsos/constants/alertsRoutingConstants';
import mapEmergencyTypeToAlertType from '@rsos/utils/mapEmergencyTypeToAlertType';

const THIRTY_SECONDS = 1000 * 30;

/**
 * Function to update an existing alert toast when the status changes
 *
 * @param {string} status - new status
 * @param {object} alert - alert object
 * @param {string} toastID - id of the toast
 * @param {object} profile - user profile
 * @returns updates the toast
 */

export const handleToastStatusChange = (status, alert, toastID, profile) => {
  if (status === ACCEPTED) {
    const sender = alert?.status?.sender || '';
    const alertResponseBy = !!sender && sender.replace(/\s/g, '').toLowerCase();
    const user = (profile?.first_name + profile?.last_name).toLowerCase();
    const whoTookAction = alertResponseBy === user ? 'You' : sender;

    if (toastID) {
      return toast.update(toastID, {
        render: toastMessageSuccess(whoTookAction + ' accepted this alert'),
        className: 'Toastify__overwrite-success',
        closeButton: true,
        autoClose: THIRTY_SECONDS,
      });
    }
  }
};

export const mockAlertToastsSettings = {
  alert_types: {
    alerts_active_assailant: {
      display_name: 'Active Assailant Alerts',
      name: 'alerts_active_assailant',
      enabled: true,
    },
    alerts_train_incident: {
      display_name: 'Train Incident Alerts',
      name: 'alerts_train_incident',
      enabled: true,
    },
    alerts_law_enforcement: {
      display_name: 'Law Enforcement Alerts',
      name: 'alerts_law_enforcement',
      enabled: true,
    },
    alerts_medical: {
      display_name: 'Medical alerts',
      name: 'alerts_medical',
      enabled: true,
    },
    alerts_test_mode: {
      display_name: 'Test Alerts',
      name: 'alerts_test_mode',
      enabled: true,
    },
    alerts_fire: {
      display_name: 'Fire Alerts',
      name: 'alerts_fire',
      enabled: true,
    },
  },
};

const notifiedAllowedAlertTypes = [
  ACTIVE_ASSAILANT_ALERT_TYPE,
  TRAIN_INCIDENT_ALERT_TYPE,
];
/**
 * Subutil to verify if the role type of an alert is eligible for an alert toast
 *
 * @param {string} roleType - Responsible or Notified role type
 * @param {string} alertType - alert type
 * @returns boolean
 */
export const shouldRoleDisplayToast = (roleType, alertType) => {
  if (roleType === NOTIFIED_AGENCY) {
    return notifiedAllowedAlertTypes.includes(alertType);
  }
  return true;
};

/**
 * Function checks if an alert suppose to display a toast
 *
 * @param {object} a - alert object
 * @param {object} resolvedAlertToastSettings - user settings for alert toasts
 * @returns boolean
 */
export const verifyEmergencyType = (a, resolvedAlertToastSettings) => {
  const isSupplementalOnly = a?.supplemental_only;
  const alertType = mapEmergencyTypeToAlertType(a?.emergency_type?.name);
  const roleType = a?.associated_role_type;
  const usersAlertTypes = resolvedAlertToastSettings?.alert_types || {};

  return !!(
    !isSupplementalOnly &&
    shouldRoleDisplayToast(roleType, alertType) &&
    usersAlertTypes[alertType]?.enabled
  );
};
